import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import type { TAuthStage } from '@/services/auth';

import { AUTH_STAGE_ROUTES } from '@/constants/auth';

import { useStaffSession } from './useStaffSession';

const useStageGuard = (expected: TAuthStage) => {
  const navigate = useNavigate();

  const { data } = useStaffSession();

  const stage = data?.stage ?? null;

  useEffect(() => {
    if (stage && stage !== expected) {
      navigate(AUTH_STAGE_ROUTES[stage], { replace: true });
    }
  }, [stage, expected, navigate]);

  return data ?? null;
};

export {
  useStageGuard,
};
